import React from 'react';
import { FontAwesomeIcon as Icon } from '@fortawesome/react-fontawesome';
import { useStyles } from './styles';
const BaseLoadingIndicator = () => {
    const ownClasses = useStyles();
    return (React.createElement("div", { className: ownClasses.root },
        React.createElement(Icon, { icon: ['fal', 'spinner'], className: "fa-pulse" })));
};
export default BaseLoadingIndicator;
